import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import styles from "./index.module.css";
import ActionButton from "../ActionButton";

class DownloadForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.user.email || "",
      newsletter: this.props.user.newsletter === false ? false : true,
      termsAgreed: this.props.user.termsAgreed || false,
      isSubmitted: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(e) {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(e) {
    this.setState({ isSubmitted: true });
    e.preventDefault();
    this.props.onSubmit(this.state);
  }

  render() {
    const { email, termsAgreed, newsletter, isSubmitted } = this.state;
    const disabled =
      termsAgreed === false || email.length < 5 || !email.includes("@");
    return (
      <div className={styles.root}>
        <h1 className={styles.title}>Download Data</h1>
        <p className={styles.body}>
          {
            "Enter an email below to continue to download the file. You'll only need to enter it once, unless you delete your cookies, and we promise not to spam you (honest)"
          }
        </p>
        <form onSubmit={this.handleSubmit} className={styles.form}>
          <div className={styles.input}>
            <label htmlFor="email" className={styles.inputLabel}>
              Email address{" "}
            </label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={this.handleInputChange}
              className={styles.inputControl}
              placeholder="Your email (required)"
            />
          </div>
          <div className={styles.checkbox}>
            <label className={styles.checkboxLabel}>
              <input
                name="termsAgreed"
                type="checkbox"
                checked={termsAgreed}
                onChange={this.handleInputChange}
                className={styles.checkboxControl}
              />
              <span style={{ display: "inline-block" }}>
                I agree to the&nbsp;
                <Link
                  className={styles.link}
                  to="/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  terms and conditions{" "}
                </Link>{" "}
                <span className={styles.required}>(required)</span>
              </span>
            </label>
          </div>
          <div className={styles.checkbox}>
            <label className={styles.checkboxLabel}>
              <input
                name="newsletter"
                type="checkbox"
                checked={newsletter}
                onChange={this.handleInputChange}
                className={styles.checkboxControl}
              />
              Please subscribe me to the Atomico mailing list
            </label>
          </div>
          <div className={styles.submit}>
            {!isSubmitted && <ActionButton disabled={disabled} />}
            {isSubmitted && (
              <span className={styles.loadingText}>Loading..</span>
            )}
          </div>
        </form>
      </div>
    );
  }
}

DownloadForm.defaultProps = {
  user: {}
};

DownloadForm.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    termsAgreed: PropTypes.bool,
    newsletter: PropTypes.bool
  }),
  onSubmit: PropTypes.func
};

export default DownloadForm;



// WEBPACK FOOTER //
// ./src/components/DownloadForm/index.js